module.exports = __webpack_public_path__ + "static/btn_044.46383648.png";